/* hs-eslint ignored failing-rules */

/* eslint-disable no-bitwise */
'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { BLOGS_FETCH } from 'DesignData/actions/ActionTypes';

function fetching(state = false, action) {
  switch (action.type) {
    case BLOGS_FETCH:
      {
        if (!action.blogs & !action.error) {
          return true;
        }

        return false;
      }

    default:
      {
        return state;
      }
  }
}

function byId(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case BLOGS_FETCH:
      {
        if (!action.blogs) {
          return state;
        }

        action.blogs.forEach(blog => {
          state = state.set(blog.id, SeamlessImmutable(blog));
        });
        return state;
      }

    default:
      return state;
  }
}

export default combineReducers({
  byId,
  fetching
});